import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_ADMINISTRACAO_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodas() {
        return axiosJwt
            .get(`${api}/controleacesso/regrasacesso`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt
            .get(`${api}/controleacesso/regrasacesso/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirRegraAcesso(regraAcesso) {
        return axiosJwt
            .post(`${api}/controleacesso/regrasacesso`, regraAcesso)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarRegraAcesso(regraAcesso) {
        return axiosJwt
            .put(`${api}/controleacesso/regrasacesso`, regraAcesso)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
